.container {
  padding: 8px 16px;
  display: flex;
  gap: 24px;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    gap: 16px;
  }
}

.controls-row {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
}

.left-controls {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    display: none;
  }
}

.controls {
  display: flex;
  gap: 24px;
  width: 100%;
  align-items: center;
}

.controls button {
  background: none;
  appearance: none;
  border: none;
  cursor: pointer;
  color: gray;
  width: 32px;
  height: 32px;
  padding: 0;
  font-family: 'Source Sans Pro', sans-serif;
}

.controls button.play {
  color: var(--text-links);
  height: 40px;
  width: 40px;
}

.container hd-icon.pause {
  display: none;
}

.container.playing hd-icon.play {
  display: none;
}

.container.playing hd-icon.pause {
  display: block;
}

.progress {
  --seek-before-width: 0%;
  --buffered-width: 0%;
  --bar-color: #CFDBF3;
  --active-bar-color: #597ABA;
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: center;
}

.progress .time {
  flex-shrink: 0;
}

input[type="range"] {
  position: relative;
  -webkit-appearance: none;
  width: 100%;
  margin: 0;
  padding: 0;
  height: 16px;
  outline: none;
  background-color: transparent;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 4px;
  cursor: pointer;
  border-radius: 4px;
  background: linear-gradient(to right, rgba(0, 125, 181, 0.6) var(--buffered-width), rgba(0, 125, 181, 0.2) var(--buffered-width));
}

input[type="range"]::before {
  position: absolute;
  content: "";
  top: 6px;
  left: 0;
  width: var(--seek-before-width);
  height: 4px;
  background-color: var(--active-bar-color);
  cursor: pointer;
  border-radius: 4px;
}

input[type="range"]::-webkit-slider-thumb {
  position: relative;
  -webkit-appearance: none;
  box-sizing: content-box;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: var(--blue-ad);
  cursor: pointer;
  margin: 0;
}

input[type="range"]:active::-webkit-slider-thumb {
  transform: scale(1.2);
  background: var(--bar-color);
}

input[type="range"]::-moz-range-track {
  width: 100%;
  height: 4px;
  cursor: pointer;
  background: linear-gradient(to right, rgba(0, 125, 181, 0.6) var(--buffered-width), rgba(0, 125, 181, 0.2) var(--buffered-width));
}

input[type="range"]::-moz-range-progress {
  background-color: var(--bar-color);
}

input[type="range"]::-moz-focus-outer {
  border: 0;
}

input[type="range"]::-moz-range-thumb {
  box-sizing: content-box;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: var(--blue-ad);
  cursor: pointer;
}

input[type="range"]:active::-moz-range-thumb {
  transform: scale(1.2);
  background: var(--bar-color);
}

input[type="range"]::-ms-track {
  width: 100%;
  height: 4px;
  cursor: pointer;
  background: transparent;
  border: solid transparent;
  color: transparent;
}

input[type="range"]::-ms-fill-lower {
  background-color: var(--bar-color);
}

input[type="range"]::-ms-fill-upper {
  background: linear-gradient(to right, rgba(0, 125, 181, 0.6) var(--buffered-width), rgba(0, 125, 181, 0.2) var(--buffered-width));
}

input[type="range"]::-ms-thumb {
  box-sizing: content-box;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: var(--blue-ad);
  cursor: pointer;
}

input[type="range"]:active::-ms-thumb {
  transform: scale(1.2);
  background: #007db5;
}

.voice-icon {
  width: 34px;
  height: 34px;
  color: var(--text-links);
}

.container.playing .voice-icon line {
  animation: pulse 1s infinite;
  transform-origin: 50% 50%;
}

.container.playing .voice-icon .voice-2 {
	animation-delay: .15s;
}

.container.playing .voice-icon .voice-2 {
	animation-delay: .30s;
}

.container.playing .voice-icon .voice-3 {
	animation-delay: .45s;
}

.container.playing .voice-icon .voice-4 {
	animation-delay: .60s;
}

.container.playing .voice-icon .voice-5 {
	animation-delay: .75s;
}

@keyframes pulse {
	0% {
		transform: scaleY(1);
		transform-origin: 50% 50%;
	}
	
	50% {
		transform: scaleY(.7);
		transform-origin: 50% 50%;
	}
	
	100% {
		transform: scaleY(1);
		transform-origin: 50% 50%;
	}
}

.played-icon {
  color: #077D55;
}

.controls .playback-rate {
  font-size: 17px;
  color: #60646B;
  padding-bottom: 2px;
  line-height: 1;
  min-width: fit-content;

  span {
    font-weight: 300;
    font-size: 27px;
  }
}
